// extracted by mini-css-extract-plugin
export default {"toggleBtnBox":"AppStatistics_toggleBtnBox__OgkNj"};